<template>
	<section class="crowdx-usecases-section">
		<div class="container">
			<!-- Header -->
			<div class="row">
				<div class="col-12">
					<h1 class="section-title-usecases headline-l">
						{{ $t('crowdxScreen.usecases.title') }}
					</h1>
					<div class="section-description text-l">
						{{ $t('crowdxScreen.usecases.description') }}
					</div>
				</div>
			</div>

			<!-- TOP: 5 small cards -->
			<div class="top-cards">
				<div
					v-for="(card, idx) in topCards"
					:key="'top-' + idx"
					class="small-card"
				>
					<div class="small-title">
						{{ card.title }}
					</div>
					<div class="small-desc">
						{{ card.description }}
					</div>
				</div>
			</div>

			<!-- BOTTOM: 2 big cards -->
			<div class="bottom-cards">
				<div
					v-for="(card, idx) in bottomCards"
					:key="'bottom-' + idx"
					class="big-card"
				>
					<h3 class="big-title headline-s">
						{{ card.title }}
					</h3>

					<div class="big-desc text-l">
						{{ card.description }}
					</div>

					<ul
						v-if="card.bullets && card.bullets.length"
						class="big-list text-l"
					>
						<li
							v-for="(b, bIdx) in card.bullets"
							:key="'b-' + idx + '-' + bIdx"
						>
							<span class="bullet-label" v-if="b.label">{{ b.label }}</span>
							<span>{{ b.text }}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'CrowdxUseCasesSection',
	computed: {
		topCards() {
			const items = this.$t('crowdxScreen.usecases.topCards');
			return Array.isArray(items) ? items : [];
		},
		bottomCards() {
			const items = this.$t('crowdxScreen.usecases.bottomCards');
			return Array.isArray(items) ? items : [];
		},
	},
};
</script>

<style lang="scss" scoped>
.crowdx-usecases-section {
	background: linear-gradient(90deg, #ce2329 0%, #ed8632 100%);
	padding: 80px 0;
	margin: 0;

	.container {
		max-width: 1300px;

		@media (max-width: $breakpoint-lg) {
			max-width: 100%;
		}
	}

	@media (max-width: $breakpoint-sm) {
		padding: 60px 0;
	}

	.section-title-usecases {
		color: #ffffff;
		text-align: center;
		margin-bottom: 16px;
		text-transform: uppercase;
	}

	.section-description {
		color: rgba(255, 255, 255, 0.95);
		text-align: center;
		line-height: 1.6;
		max-width: 980px;
		margin: 0 auto 60px;

		@media (max-width: $breakpoint-sm) {
			margin-bottom: 40px;
		}
	}

	/* ===== Top 5 cards ===== */
	.top-cards {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 30px;
		margin-bottom: 30px;

		@media (max-width: $breakpoint-sm) {
			margin-bottom: 30px;
		}
	}

	.small-card {
		background: #ffffff;
		border-radius: 2px;
		//min-height: 230px;
		//max-width: 220px;
		height: 113px;
		width: 220px;
		padding: 26px 12px;
		box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.18);

		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		text-align: center;

		@media (max-width: $breakpoint-sm) {
			min-height: 200px;
			max-width: unset;
			width: 100%;
		}
	}

	.small-title {
		color: #26262b;
		font-family: 'HKNova-Bold', sans-serif;
		font-size: 16px;
		line-height: 24px;
		margin-bottom: 6px;
		max-width: 220px;
	}

	.small-desc {
		color: #26262b;
		font-size: 15px;
		line-height: 22px;
		max-width: 240px;
	}

	/* ===== Bottom 2 big cards ===== */
	.bottom-cards {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 30px;

		@media (max-width: $breakpoint-md) {
			grid-template-columns: 1fr;
			gap: 24px;
		}
	}

	.big-card {
		background: #ffffff;
		border-radius: 2px;
		padding-left: 30px;
		padding-right: 15px;
		padding-top: 30px;
		padding-bottom: 15px;
		box-shadow: 0px 14px 40px rgba(0, 0, 0, 0.22);

		@media (max-width: $breakpoint-sm) {
			padding: 26px 22px;
			min-height: auto;
		}
	}

	.big-title {
		color: #050535;
		font-family: 'HKNova-Bold', sans-serif;
		margin: 0 0 30px 0;
		font-size: 28px;
		line-height: 24px;

		@media (max-width: $breakpoint-sm) {
			font-size: 22px;
		}
	}

	.big-desc {
		color: #050535;
		font-family: 'HKNova-Light', sans-serif;
		line-height: 24px;
		margin-bottom: 16px;
		max-width: 465px;
	}

	.big-list {
		padding-left: 20px;
		margin: 0;
		font-family: 'HKNova-Light', sans-serif;
		max-width: 465px;

		li {
			margin: 10px 0;
			line-height: 24px;
			color: #050535;
		}
	}

	.bullet-label {
		font-family: 'HKNova-Bold', sans-serif;
		margin-right: 2px;
	}
}
</style>
